const generateEndValue = (value: string | number): number => {
  const isTypeofValueString = typeof value === 'string';
  const endValue = isTypeofValueString
    ? (value.codePointAt(0) as number)
    : value + 10;

  return endValue;
};

const generateStartValue = (
  value: string | number,
  isAnimationActive?: boolean,
): number => {
  const isTypeofValueString = typeof value === 'string';
  const endValue = generateEndValue(value);
  const startValue = isTypeofValueString ? endValue - 10 : 0;

  return isAnimationActive ? startValue : endValue;
};

interface CountUpLimitsReturnType {
  end: number;
  start: number;
}

const createCountUpLimits = (
  value: string | number,
  isAnimationActive?: boolean,
): CountUpLimitsReturnType => {
  return {
    start: generateStartValue(value, isAnimationActive),
    end: generateEndValue(value),
  };
};

const createFormatingFn = (value: string | number) => {
  const isTypeofValueString = typeof value === 'string';

  return (number: number): string => {
    if (isTypeofValueString) {
      const difference = number - 65;

      return difference < 0
        ? String.fromCodePoint(91 + difference)
        : String.fromCodePoint(number);
    } else {
      return String(number).slice(-1);
    }
  };
};

export { createCountUpLimits, createFormatingFn };
